<template>
  <v-container fluid>
    <v-row>
      <v-col cols=4>
        <!-- graph storeUrl="stats/turnover" :options="{range:12, shopId:1}" label="Turnover Miura" / -->
      </v-col>
      <v-col cols=4>
        <!-- graph storeUrl="stats/turnover" :options="{range:12, shopId:2}" label="Turnover Truespec" / -->
      </v-col>
      <v-col cols=4>
        <!-- graph storeUrl="stats/turnover" :options="{range:12}" label="Turnover Global" / -->
      </v-col>
    </v-row>
    <v-row>
      <v-col cols=4>
        <!-- graph storeUrl="stats/pnl" :options="{range:12, shopId:1}" label="PnL Miura" / -->
      </v-col>
      <v-col cols=4>
        <!-- graph storeUrl="stats/pnl" :options="{range:12, shopId:2}" label="PnL Truespec" / -->
      </v-col>
      <v-col cols=4>
        <!-- graph storeUrl="stats/pnl" :options="{range:12}" label="PnL Global" / -->
      </v-col>
    </v-row>
  </v-container>
  
</template>

<script>
// import Graph from "@components/dashboard/Graph"
export default {
  components:{
    //Graph
  },
  data: () => ({
    turnover:null,
    turnover2:null,
    turnover3:null
  }),
  mounted(){
    this.getData();
  },
  methods:{
    getData(){
      /*this.$store.dispatch("stats/turnover",{range:12, shopId:1})
      .then((data) => {
        this.turnover = data;
      })

      this.$store.dispatch("stats/turnover",{range:12, shopId:2})
      .then((data) => {
        this.turnover2 = data;
      })

      this.$store.dispatch("stats/turnover",{range:12})
      .then((data) => {
        this.turnover3 = data;
      })*/
    }
  }

};
</script>
